import * as React from 'react'
import Typography from '@mui/material/Typography'
import { SxProps } from '@mui/material'

interface Props {
  children?: React.ReactElement | string | number
  sx?: SxProps
  component?: any
  bold?: boolean
}

/**
 * 表示値
 */
export const DisplayValue: React.FC<Props> = (props) => {
  const { children, sx, bold } = props
  const component = props.component ? props.component : 'p'

  return (
    <Typography
      component={component}
      sx={{
        color: '#000',
        fontWeight: bold ? 'bold' : 'normal',
        ...sx,
      }}
    >
      {children}
    </Typography>
  )
}

export default DisplayValue
